export default __webpack_public_path__ + "static/media/foto_01.130572b2.svg";